(function () {
  "use strict";

  if (window.__sarasinArticleLoaded) {
    return;
  }
  window.__sarasinArticleLoaded = true;

  var ROOT_SELECTOR = "[data-sarasin-article]";
  var CONTENT_SELECTOR = "[data-article-content]";
  var instances = new WeakMap();
  var mediaId = 0;

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function normaliseHeading(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function normaliseToken(value) {
    return String(value || "")
      .trim()
      .toLocaleLowerCase()
      .replace(/[\s_]+/g, "-")
      .replace(/-+/g, "-");
  }

  function slugify(value) {
    return normaliseHeading(value).replace(/\s+/g, "-").replace(/^-|-$/g, "");
  }

  function directChildrenMatching(parent, selector) {
    return toArray(parent ? parent.children : []).filter(function (child) {
      return child.matches(selector);
    });
  }

  function articleHeadings(content, selector) {
    return toArray(content ? content.querySelectorAll(selector) : []).filter(function (heading) {
      return !heading.closest("[data-article-module]") && normaliseHeading(heading.textContent) !== "";
    });
  }

  function pruneEmptyContent(content) {
    toArray(content.querySelectorAll("h2, h3, h4, p")).forEach(function (element) {
      var hasMeaningfulText = String(element.textContent || "").replace(/\u00a0/g, " ").trim() !== "";
      var hasEmbeddedContent = Boolean(element.querySelector("img, picture, video, iframe, audio, svg, table"));

      if (!hasMeaningfulText && !hasEmbeddedContent) {
        element.remove();
      }
    });
  }

  function normaliseRichTextWhitespace(content) {
    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    var textNode = walker.nextNode();

    while (textNode) {
      var parent = textNode.parentElement;

      if (
        textNode.nodeValue.indexOf("\u00a0") !== -1 &&
        (!parent || !parent.closest("pre, code"))
      ) {
        textNode.nodeValue = textNode.nodeValue.replace(/\u00a0/g, " ");
      }

      textNode = walker.nextNode();
    }
  }

  function assignUniqueHeadingIds(root, headings) {
    var headingSet = new Set(headings);
    var reservedIds = new Set();
    var claimedIds = new Set();
    var rootKey = slugify(root.id || root.getAttribute("data-section-id") || "article");

    toArray(document.querySelectorAll("[id]")).forEach(function (element) {
      if (!headingSet.has(element) && element.id) {
        reservedIds.add(element.id);
      }
    });

    headings.forEach(function (heading, index) {
      var existingId = heading.id ? heading.id.trim() : "";

      if (existingId && !/\s/.test(existingId) && !reservedIds.has(existingId) && !claimedIds.has(existingId)) {
        claimedIds.add(existingId);
      } else {
        var textSlug = slugify(heading.textContent) || "section-" + (index + 1);
        var baseId = ["article", rootKey, textSlug].filter(Boolean).join("-");
        var candidate = baseId;
        var suffix = 2;

        while (reservedIds.has(candidate) || claimedIds.has(candidate)) {
          candidate = baseId + "-" + suffix;
          suffix += 1;
        }

        heading.id = candidate;
        claimedIds.add(candidate);
      }

      if (!heading.hasAttribute("tabindex")) {
        heading.setAttribute("tabindex", "-1");
      }
    });
  }

  function wrapHeadingGroups(content) {
    var childNodes = toArray(content.childNodes);
    var currentSection = null;

    childNodes.forEach(function (node) {
      if (node.nodeType === 1 && node.matches("h2")) {
        currentSection = document.createElement("section");
        currentSection.className = "t-article__content-section";
        currentSection.setAttribute("aria-labelledby", node.id);
        content.insertBefore(currentSection, node);
        currentSection.appendChild(node);
      } else if (currentSection) {
        currentSection.appendChild(node);
      }
    });

    directChildrenMatching(content, ".t-article__content-section").forEach(function (section) {
      var heading = directChildrenMatching(section, "h2")[0] || section.querySelector("h2");
      if (heading) {
        section.setAttribute("aria-labelledby", heading.id);
      }
    });
  }

  function wrapSubsections(content) {
    directChildrenMatching(content, ".t-article__content-section").forEach(function (section) {
      if (directChildrenMatching(section, ".t-article__subsection-grid").length) {
        return;
      }

      var nodes = toArray(section.childNodes);
      var h3Count = nodes.filter(function (node) {
        return node.nodeType === 1 && node.matches("h3");
      }).length;

      if (h3Count < 2) {
        return;
      }

      var firstH3Index = nodes.findIndex(function (node) {
        return node.nodeType === 1 && node.matches("h3");
      });
      var grid = document.createElement("div");
      var card = null;

      grid.className = "t-article__subsection-grid";
      section.insertBefore(grid, nodes[firstH3Index]);

      nodes.slice(firstH3Index).forEach(function (node) {
        if (node.nodeType === 1 && node.matches("h3")) {
          card = document.createElement("section");
          card.className = "t-article__subsection-card";
          card.setAttribute("aria-labelledby", node.id);
          grid.appendChild(card);
        }

        if (card) {
          card.appendChild(node);
        }
      });
    });
  }

  function stableInsertAfter(anchor, module, anchors) {
    var previousModule = anchors.get(anchor);
    if (previousModule && previousModule.isConnected) {
      previousModule.after(module);
    } else {
      anchor.after(module);
    }
    anchors.set(anchor, module);
  }

  function placeModuleAtHeading(module, heading, position, insertionState) {
    var isSubheading = heading.matches("h3");
    var container = isSubheading
      ? heading.closest(".t-article__subsection-card") || heading.closest(".t-article__content-section")
      : heading.closest(".t-article__content-section");
    var token = normaliseToken(position) || "after-section";

    if (isSubheading && module.classList.contains("t-article__module--breakout")) {
      var breakoutAnchor =
        heading.closest(".t-article__subsection-grid") ||
        heading.closest(".t-article__subsection-card") ||
        container ||
        heading;

      if (token === "before" || token === "before-heading" || token === "heading-before") {
        breakoutAnchor.before(module);
      } else {
        stableInsertAfter(breakoutAnchor, module, insertionState.afterSection);
      }
      return;
    }

    if (token === "before" || token === "before-heading" || token === "heading-before") {
      heading.before(module);
    } else if (
      token === "after" ||
      token === "after-heading" ||
      token === "heading-after" ||
      token === "section-start" ||
      token === "start-of-section" ||
      token === "inside-start"
    ) {
      stableInsertAfter(heading, module, insertionState.afterHeading);
    } else if (token === "before-section" || token === "section-before" || token === "before-group") {
      (container || heading).before(module);
    } else if (
      token === "section-end" ||
      token === "end-of-section" ||
      token === "inside-end" ||
      (isSubheading && (token === "after-section" || token === "section-after" || token === "after-group"))
    ) {
      (container || heading.parentElement).appendChild(module);
    } else {
      stableInsertAfter(container || heading, module, insertionState.afterSection);
    }
  }

  function placeModuleAtFallback(module, content, fallbackPosition, insertionState) {
    var sections = directChildrenMatching(content, ".t-article__content-section");
    var token = normaliseToken(fallbackPosition) || "end";
    var numberMatch = token.match(/(?:^|after-)(\d+)(?:-section)?$/);
    var wordPositions = {
      "after-first": 1,
      "after-first-section": 1,
      "after-second": 2,
      "after-second-section": 2,
      "after-third": 3,
      "after-third-section": 3
    };
    var requestedIndex = numberMatch ? parseInt(numberMatch[1], 10) : wordPositions[token];

    if (token === "hide" || token === "hidden" || token === "none") {
      return false;
    }

    if (token === "start" || token === "beginning" || token === "before-first-section" || token === "after-intro") {
      if (sections[0]) {
        sections[0].before(module);
      } else {
        content.prepend(module);
      }
    } else if (token === "middle" && sections.length) {
      stableInsertAfter(sections[Math.ceil(sections.length / 2) - 1], module, insertionState.fallback);
    } else if (requestedIndex !== undefined && sections.length) {
      var sectionIndex = Math.max(0, Math.min(requestedIndex - 1, sections.length - 1));
      stableInsertAfter(sections[sectionIndex], module, insertionState.fallback);
    } else {
      content.appendChild(module);
    }

    return true;
  }

  function placeModules(root, content) {
    var modules = toArray(root.querySelectorAll("[data-article-module]"));
    var headings = articleHeadings(content, "h2, h3");
    var insertionState = {
      afterHeading: new WeakMap(),
      afterSection: new WeakMap(),
      fallback: new WeakMap()
    };

    modules.forEach(function (module) {
      var requestedHeading = normaliseHeading(module.getAttribute("data-insert-after"));
      var matchedHeading = requestedHeading
        ? headings.find(function (heading) {
            return normaliseHeading(heading.textContent) === requestedHeading;
          })
        : null;

      var position = normaliseToken(module.getAttribute("data-insert-position"));
      var wasPlaced = true;

      if (position === "end" || position === "article-end" || position === "end-of-article") {
        content.appendChild(module);
      } else if (matchedHeading) {
        placeModuleAtHeading(module, matchedHeading, position, insertionState);
      } else {
        wasPlaced = placeModuleAtFallback(
          module,
          content,
          module.getAttribute("data-fallback-position"),
          insertionState
        );
      }

      if (!wasPlaced) {
        module.hidden = true;
        module.setAttribute("aria-hidden", "true");
        return;
      }

      module.hidden = false;
      module.removeAttribute("aria-hidden");
      module.classList.add("is-placed");
    });
  }

  function buildTableOfContents(root, h2Headings) {
    var lists = toArray(root.querySelectorAll("[data-toc-list]"));
    var shells = toArray(root.querySelectorAll("[data-toc-shell]"));
    var linksById = new Map();

    shells.forEach(function (shell) {
      shell.hidden = h2Headings.length < 2;
      if (h2Headings.length < 2) {
        shell.setAttribute("aria-hidden", "true");
      } else {
        shell.removeAttribute("aria-hidden");
      }
    });

    lists.forEach(function (list) {
      list.replaceChildren();

      h2Headings.forEach(function (heading) {
        var link = document.createElement("a");
        var item = document.createElement("li");

        link.className = "t-article__toc-link";
        link.href = "#" + heading.id;
        link.textContent = heading.textContent.trim();
        link.setAttribute("data-toc-target", heading.id);

        if (list.matches("ul, ol")) {
          item.appendChild(link);
          list.appendChild(item);
        } else {
          list.appendChild(link);
        }

        if (!linksById.has(heading.id)) {
          linksById.set(heading.id, []);
        }
        linksById.get(heading.id).push(link);
      });
    });

    function setActive(id) {
      linksById.forEach(function (links, headingId) {
        links.forEach(function (link) {
          var active = headingId === id;
          link.classList.toggle("is-active", active);
          if (active) {
            link.setAttribute("aria-current", "location");
          } else {
            link.removeAttribute("aria-current");
          }
        });
      });
    }

    if (!h2Headings.length) {
      return null;
    }

    setActive(h2Headings[0].id);

    if (!("IntersectionObserver" in window)) {
      return null;
    }

    var observer = new IntersectionObserver(
      function () {
        var marker = window.innerHeight * 0.3;
        var current = h2Headings[0];

        h2Headings.forEach(function (heading) {
          if (heading.getBoundingClientRect().top <= marker) {
            current = heading;
          }
        });

        setActive(current.id);
      },
      {
        rootMargin: "-15% 0px -70% 0px",
        threshold: [0, 0.2, 0.8]
      }
    );

    h2Headings.forEach(function (heading) {
      observer.observe(heading);
    });

    return observer;
  }

  function updateSidebarState(root, h2Headings) {
    var layout = root.querySelector("[data-reading-layout]");
    var sidebar = root.querySelector(".t-article__sidebar");

    if (!layout || !sidebar) {
      if (layout) {
        layout.classList.remove("t-article__reading-layout--with-sidebar");
      }
      return;
    }

    var hasShare = Boolean(sidebar.querySelector(".t-article__share"));
    var hasToc = Boolean(sidebar.querySelector("[data-toc-shell]")) && h2Headings.length >= 2;
    var hasControls = hasShare || hasToc;

    sidebar.hidden = !hasControls;
    layout.classList.toggle("t-article__reading-layout--with-sidebar", hasControls);
  }

  function activateDataSources(scope) {
    toArray(scope.querySelectorAll("[data-src], [data-srcset]")).forEach(function (element) {
      if (element.dataset.src) {
        element.setAttribute("src", element.dataset.src);
        element.removeAttribute("data-src");
      }
      if (element.dataset.srcset) {
        element.setAttribute("srcset", element.dataset.srcset);
        element.removeAttribute("data-srcset");
      }
    });
  }

  function setupDeferredMedia(root, on) {
    toArray(root.querySelectorAll("[data-deferred-media]")).forEach(function (media) {
      var button = media.querySelector("[data-media-play]");
      var template = media.querySelector("template[data-media-template]");

      if (!button || !template || media.dataset.mediaLoaded === "true") {
        return;
      }

      if (button.matches("button") && !button.hasAttribute("type")) {
        button.type = "button";
      }
      if (!button.hasAttribute("aria-expanded")) {
        button.setAttribute("aria-expanded", "false");
      }

      on(button, "click", function (event) {
        event.preventDefault();

        if (media.dataset.mediaLoaded === "true") {
          return;
        }

        var fragment = template.content.cloneNode(true);
        var focusTarget = fragment.querySelector("iframe, video, [tabindex], a, button");
        var mount = media.querySelector("[data-media-mount]");

        if (!fragment.childNodes.length) {
          return;
        }

        media.dataset.mediaLoaded = "true";
        media.setAttribute("aria-busy", "true");
        activateDataSources(fragment);

        toArray(fragment.querySelectorAll("iframe")).forEach(function (iframe) {
          if (!iframe.title) {
            iframe.title =
              media.getAttribute("data-media-title") ||
              button.getAttribute("data-media-title") ||
              button.getAttribute("aria-label") ||
              document.title;
          }
        });

        toArray(fragment.querySelectorAll("video")).forEach(function (video) {
          video.controls = true;
          video.playsInline = true;
        });

        if (focusTarget) {
          if (!focusTarget.id) {
            mediaId += 1;
            focusTarget.id = "sarasin-article-media-" + mediaId;
          }
          button.setAttribute("aria-controls", focusTarget.id);
        }

        if (mount) {
          mount.replaceChildren(fragment);
        } else {
          media.appendChild(fragment);
        }

        media.classList.add("is-active");
        media.removeAttribute("aria-busy");
        button.setAttribute("aria-expanded", "true");
        button.hidden = true;

        window.requestAnimationFrame(function () {
          var liveTarget = focusTarget && focusTarget.isConnected ? focusTarget : media.querySelector("iframe, video");
          var video = media.querySelector("video");

          if (liveTarget && typeof liveTarget.focus === "function") {
            liveTarget.focus({ preventScroll: true });
          }
          if (video) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(function () {});
            }
          }
        });
      });
    });
  }

  function legacyCopy(text) {
    var input = document.createElement("textarea");
    var activeElement = document.activeElement;

    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    input.style.pointerEvents = "none";
    document.body.appendChild(input);
    input.focus();
    input.select();

    var copied = document.execCommand("copy");
    input.remove();

    if (activeElement && typeof activeElement.focus === "function") {
      activeElement.focus({ preventScroll: true });
    }
    if (!copied) {
      throw new Error("Copy command was not available");
    }
  }

  async function copyText(text) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (error) {
        legacyCopy(text);
        return;
      }
    }
    legacyCopy(text);
  }

  function setupSharing(root, on, timers) {
    var feedbackStates = new Map();

    function showFeedback(button, label) {
      if (!label) {
        return;
      }

      var state = feedbackStates.get(button);
      var existingTimer = timers.get(button);
      var duration = parseInt(button.getAttribute("data-success-duration"), 10) || 2200;

      if (!state) {
        var labelTarget = button.querySelector("[data-button-label], [data-share-label], [data-copy-label]");
        var target = labelTarget || button;
        state = {
          labelTarget: labelTarget,
          target: target,
          originalContent: labelTarget ? target.textContent : target.innerHTML,
          originalAriaLabel: button.getAttribute("aria-label")
        };
        feedbackStates.set(button, state);
      }

      if (existingTimer) {
        window.clearTimeout(existingTimer);
      }

      state.target.textContent = label;
      button.setAttribute("aria-label", label);
      button.setAttribute("aria-live", "polite");

      timers.set(
        button,
        window.setTimeout(function () {
          if (state.labelTarget) {
            state.target.textContent = state.originalContent;
          } else {
            state.target.innerHTML = state.originalContent;
          }
          if (state.originalAriaLabel === null) {
            button.removeAttribute("aria-label");
          } else {
            button.setAttribute("aria-label", state.originalAriaLabel);
          }
          button.removeAttribute("aria-live");
          timers.delete(button);
          feedbackStates.delete(button);
        }, duration)
      );
    }

    function shareUrl(button) {
      return (
        button.getAttribute("data-share-url") ||
        root.getAttribute("data-article-url") ||
        (document.querySelector('link[rel="canonical"]') || {}).href ||
        window.location.href
      );
    }

    toArray(root.querySelectorAll("[data-share-article]")).forEach(function (button) {
      if (button.matches("button") && !button.hasAttribute("type")) {
        button.type = "button";
      }

      on(button, "click", async function (event) {
        event.preventDefault();

        var url = shareUrl(button);
        var payload = {
          title: button.getAttribute("data-share-title") || root.getAttribute("data-article-title") || document.title,
          text: button.getAttribute("data-share-text") || root.getAttribute("data-article-share-text") || "",
          url: url
        };

        try {
          if (typeof navigator.share === "function" && (!navigator.canShare || navigator.canShare(payload))) {
            await navigator.share(payload);
          } else {
            await copyText(url);
          }
          showFeedback(button, button.getAttribute("data-success-label"));
        } catch (error) {
          if (error && error.name === "AbortError") {
            return;
          }

          try {
            await copyText(url);
            showFeedback(button, button.getAttribute("data-success-label"));
          } catch (copyError) {
            showFeedback(button, button.getAttribute("data-error-label"));
          }
        }
      });
    });

    toArray(root.querySelectorAll("[data-copy-link]")).forEach(function (button) {
      if (button.matches("button") && !button.hasAttribute("type")) {
        button.type = "button";
      }

      on(button, "click", async function (event) {
        event.preventDefault();
        try {
          await copyText(shareUrl(button));
          showFeedback(button, button.getAttribute("data-success-label"));
        } catch (error) {
          showFeedback(button, button.getAttribute("data-error-label"));
        }
      });
    });
  }

  function setupRelatedCarousel(root, on) {
    var carousel = root.querySelector("[data-related-carousel]");
    if (!carousel) {
      return null;
    }

    var sliderId = carousel.getAttribute("data-related-slider-id");
    var slider = sliderId ? document.getElementById(sliderId) : null;
    var controls = carousel.querySelector("[data-related-controls]");
    var previousButton = carousel.querySelector("[data-related-previous]");
    var nextButton = carousel.querySelector("[data-related-next]");
    var toggleButton = carousel.querySelector("[data-related-toggle]");
    var autoplayEnabled = carousel.getAttribute("data-related-autoplay") === "true";
    var pauseOnHover = carousel.getAttribute("data-related-pause-on-hover") === "true";
    var motionQuery = window.matchMedia
      ? window.matchMedia("(prefers-reduced-motion: reduce)")
      : null;
    var manuallyPaused = false;
    var motionPaused = Boolean(motionQuery && motionQuery.matches);
    var focusPaused = false;
    var pointerPaused = false;
    var isVisible = true;
    var visibilityObserver = null;
    var initialisationObserver = null;
    var connectedSwiper = null;
    var swiperEvents = [];

    if (!slider || !controls) {
      return null;
    }

    function getSwiper() {
      return slider.swiper && !slider.swiper.destroyed ? slider.swiper : null;
    }

    function shouldPause() {
      return manuallyPaused || motionPaused || focusPaused || pointerPaused || document.hidden || !isVisible;
    }

    function updateToggle(paused) {
      if (!toggleButton) {
        return;
      }

      var pauseLabel = toggleButton.getAttribute("data-pause-label") || "Pause slideshow";
      var playLabel = toggleButton.getAttribute("data-play-label") || "Play slideshow";

      toggleButton.classList.toggle("is-paused", paused);
      toggleButton.setAttribute("aria-label", paused ? playLabel : pauseLabel);
    }

    function updateSlideAccessibility(swiper) {
      if (!swiper || !swiper.slides) {
        return;
      }

      toArray(swiper.slides).forEach(function (slide, index) {
        var isCurrent = slide.classList.contains("swiper-slide-visible");
        var originalIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        var slideNumber = Number.isNaN(originalIndex) ? index + 1 : originalIndex + 1;

        slide.setAttribute("aria-label", slideNumber + " / " + swiper.slides.length);
        slide.toggleAttribute("inert", !isCurrent);
        if (isCurrent) {
          slide.removeAttribute("aria-hidden");
        } else {
          slide.setAttribute("aria-hidden", "true");
        }
      });
    }

    function applyAutoplayState(swiperOverride) {
      var swiper = swiperOverride || getSwiper();
      if (!swiper) {
        return false;
      }

      controls.hidden = false;

      if (!autoplayEnabled || !swiper.autoplay) {
        if (swiper.wrapperEl) {
          swiper.wrapperEl.setAttribute("aria-live", "polite");
        }
        updateSlideAccessibility(swiper);
        return true;
      }

      if (shouldPause()) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
        if (swiper.autoplay.paused && typeof swiper.autoplay.resume === "function") {
          swiper.autoplay.resume();
        }
      }

      updateToggle(manuallyPaused || motionPaused);
      if (swiper.wrapperEl) {
        swiper.wrapperEl.setAttribute("aria-live", shouldPause() ? "polite" : "off");
      }
      updateSlideAccessibility(swiper);
      return true;
    }

    function bindSwiperEvent(swiper, eventName, handler) {
      if (swiper && typeof swiper.on === "function") {
        swiper.on(eventName, handler);
        swiperEvents.push([swiper, eventName, handler]);
      }
    }

    function connectSwiper() {
      var swiper = getSwiper();
      if (!swiper || connectedSwiper === swiper) {
        return Boolean(swiper);
      }

      connectedSwiper = swiper;
      controls.hidden = false;

      var updateAccessibility = function () {
        window.requestAnimationFrame(function () {
          updateSlideAccessibility(swiper);
        });
      };

      bindSwiperEvent(swiper, "slideChange", updateAccessibility);
      bindSwiperEvent(swiper, "slideChangeTransitionEnd", updateAccessibility);
      bindSwiperEvent(swiper, "breakpoint", updateAccessibility);
      bindSwiperEvent(swiper, "resize", updateAccessibility);
      bindSwiperEvent(swiper, "observerUpdate", updateAccessibility);
      applyAutoplayState(swiper);
      return true;
    }

    if (previousButton) {
      on(previousButton, "click", function () {
        var swiper = getSwiper();
        if (swiper) {
          swiper.slidePrev();
          applyAutoplayState();
        }
      });
    }

    if (nextButton) {
      on(nextButton, "click", function () {
        var swiper = getSwiper();
        if (swiper) {
          swiper.slideNext();
          applyAutoplayState();
        }
      });
    }

    if (toggleButton) {
      on(toggleButton, "click", function () {
        if (motionPaused) {
          motionPaused = false;
          manuallyPaused = false;
        } else {
          manuallyPaused = !manuallyPaused;
        }
        applyAutoplayState();
      });
    }

    if (pauseOnHover) {
      on(carousel, "mouseenter", function () {
        pointerPaused = true;
        applyAutoplayState();
      });

      on(carousel, "mouseleave", function () {
        pointerPaused = false;
        applyAutoplayState();
      });
    }

    on(slider, "focusin", function () {
      focusPaused = true;
      applyAutoplayState();
    });

    on(slider, "focusout", function (event) {
      if (!event.relatedTarget || !slider.contains(event.relatedTarget)) {
        focusPaused = false;
        applyAutoplayState();
      }
    });

    on(document, "visibilitychange", applyAutoplayState);

    if (motionQuery) {
      on(motionQuery, "change", function (event) {
        motionPaused = event.matches;
        applyAutoplayState();
      });
    }

    if ("IntersectionObserver" in window) {
      visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === carousel) {
              isVisible = entry.isIntersecting;
              applyAutoplayState();
            }
          });
        },
        { rootMargin: "10% 0px", threshold: 0.01 }
      );
      visibilityObserver.observe(carousel);
    }

    if (!connectSwiper() && "MutationObserver" in window) {
      initialisationObserver = new MutationObserver(function () {
        if (connectSwiper()) {
          initialisationObserver.disconnect();
          initialisationObserver = null;
        }
      });
      initialisationObserver.observe(slider, { attributes: true, attributeFilter: ["class"] });
    }

    return function () {
      if (initialisationObserver) {
        initialisationObserver.disconnect();
      }
      if (visibilityObserver) {
        visibilityObserver.disconnect();
      }
      swiperEvents.forEach(function (binding) {
        if (binding[0] && !binding[0].destroyed && typeof binding[0].off === "function") {
          binding[0].off(binding[1], binding[2]);
        }
      });
    };
  }

  function setupReadingProgress(root, on) {
    var progress = root.querySelector("[data-reading-progress]");
    if (!progress) {
      return null;
    }

    var frame = null;

    if (progress.matches("progress")) {
      progress.max = 100;
    } else {
      progress.setAttribute("role", "progressbar");
      progress.setAttribute("aria-valuemin", "0");
      progress.setAttribute("aria-valuemax", "100");
    }

    function update() {
      frame = null;
      var rect = root.getBoundingClientRect();
      var start = rect.top + window.scrollY;
      var distance = Math.max(root.scrollHeight - window.innerHeight, 1);
      var amount = Math.max(0, Math.min(1, (window.scrollY - start) / distance));
      var percentage = Math.round(amount * 100);

      root.style.setProperty("--article-reading-progress", String(amount));
      progress.style.setProperty("--article-reading-progress", String(amount));
      progress.style.setProperty("--reading-progress", String(amount));
      progress.setAttribute("aria-valuenow", String(percentage));

      if (progress.matches("progress")) {
        progress.value = percentage;
      } else {
        progress.style.transform = "scaleX(" + amount + ")";
      }
    }

    function requestUpdate() {
      if (frame === null) {
        frame = window.requestAnimationFrame(update);
      }
    }

    on(window, "scroll", requestUpdate, { passive: true });
    on(window, "resize", requestUpdate, { passive: true });
    requestUpdate();

    return function () {
      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }
    };
  }

  function setupReveals(root) {
    var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var targets = toArray(
      root.querySelectorAll(
        ".t-article__reveal, .t-article__content-section, .t-article__subsection-card, [data-article-module].is-placed"
      )
    ).filter(function (target, index, collection) {
      return collection.indexOf(target) === index;
    });

    if (reducedMotion || !("IntersectionObserver" in window)) {
      targets.forEach(function (target) {
        target.classList.add("is-visible");
      });
      return null;
    }

    root.classList.add("is-reveal-ready");

    targets.forEach(function (target, index) {
      target.classList.add("t-article__reveal");
      target.style.setProperty("--reveal-index", String(index % 4));
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.01 }
    );

    targets.forEach(function (target) {
      observer.observe(target);
    });

    return observer;
  }

  function initialise(root) {
    if (!root || instances.has(root)) {
      return;
    }

    var listeners = [];
    var timers = new Map();
    var observers = [];
    var cleanups = [];
    var content = root.matches(CONTENT_SELECTOR) ? root : root.querySelector(CONTENT_SELECTOR);

    function on(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push([target, type, handler, options]);
    }

    root.classList.add("is-enhanced");

    if (content) {
      normaliseRichTextWhitespace(content);
      pruneEmptyContent(content);
      var headings = articleHeadings(content, "h2, h3");
      assignUniqueHeadingIds(root, headings);
      wrapHeadingGroups(content);
      if (root.getAttribute("data-enhance-subsections") !== "false") {
        wrapSubsections(content);
      }
      placeModules(root, content);

      var h2Headings = articleHeadings(content, "h2");
      var tocObserver = buildTableOfContents(root, h2Headings);
      updateSidebarState(root, h2Headings);
      if (tocObserver) {
        observers.push(tocObserver);
      }
    } else {
      toArray(root.querySelectorAll("[data-article-module]")).forEach(function (module) {
        module.hidden = false;
        module.removeAttribute("aria-hidden");
        module.classList.add("is-placed");
      });
      buildTableOfContents(root, []);
      updateSidebarState(root, []);
    }

    setupDeferredMedia(root, on);
    setupSharing(root, on, timers);

    var cancelRelatedCarousel = setupRelatedCarousel(root, on);
    if (cancelRelatedCarousel) {
      cleanups.push(cancelRelatedCarousel);
    }

    var cancelProgress = setupReadingProgress(root, on);
    if (cancelProgress) {
      cleanups.push(cancelProgress);
    }

    var revealObserver = setupReveals(root);
    if (revealObserver) {
      observers.push(revealObserver);
    }

    instances.set(root, {
      destroy: function () {
        listeners.forEach(function (listener) {
          listener[0].removeEventListener(listener[1], listener[2], listener[3]);
        });
        observers.forEach(function (observer) {
          observer.disconnect();
        });
        cleanups.forEach(function (cleanup) {
          cleanup();
        });
        timers.forEach(function (timer) {
          window.clearTimeout(timer);
        });
        instances.delete(root);
      }
    });
  }

  function rootsWithin(scope) {
    var roots = [];

    if (!scope) {
      return roots;
    }
    if (scope.nodeType === 1 && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }
    if (scope.querySelectorAll) {
      roots = roots.concat(toArray(scope.querySelectorAll(ROOT_SELECTOR)));
    }

    return roots;
  }

  function initialiseWithin(scope) {
    rootsWithin(scope).forEach(initialise);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialiseWithin(document);
    });
  } else {
    initialiseWithin(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialiseWithin(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    rootsWithin(event.target).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) {
        instance.destroy();
      }
    });
  });
})();
